module.exports = __webpack_public_path__ + "img/external-link-square-alt.9f62e363.svg";